import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_API_CHANGER_MOT_DE_PASSE,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE,
    CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE,
    CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE,
    CONTEXT_MODIFIER_PERSONNE_PHYSIQUE,
    CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE,
    CONTEXT_API_RECUPERER_ADRESSE_SECONDAIRE,
    CONTEXT_API_MODIFIER_ADRESSE_SECONDAIRE,
    CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE,
    CONTEXT_API_MODIFIER_QUESTIONS_REPONSES,
    CONTEXT_API_RECUPERER_QUESTIONS,
    CONTEXT_API_AJOUTER_PERSONA,
    CONTEXT_API_RECUPERER_QUOTA,
    CONTEXT_API_VERIFIER_CODE_POSTAL,
} from '../../constants/apiUrls.constants';

const monCompte = combineReducers({
    changerMotDePasse: APIReducer.bind(null, CONTEXT_API_CHANGER_MOT_DE_PASSE),
    recupererInformationsPersonnelles: APIReducer.bind(
        null,
        CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    ),
    recupererQuota: APIReducer.bind(null, CONTEXT_API_RECUPERER_QUOTA),
    recuperationAdressePrincipale: APIReducer.bind(null, CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE),
    recuperationAdresseSecondaire: APIReducer.bind(null, CONTEXT_API_RECUPERER_ADRESSE_SECONDAIRE),
    ajoutAdresseSecondaire: APIReducer.bind(null, CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE),
    suppressionAdresseSecondaire: APIReducer.bind(null, CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE),
    modificationAdressePrincipale: APIReducer.bind(null, CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE),
    modificationAdresseSecondaire: APIReducer.bind(null, CONTEXT_API_MODIFIER_ADRESSE_SECONDAIRE),
    modifierPersonnePhysique: APIReducer.bind(null, CONTEXT_MODIFIER_PERSONNE_PHYSIQUE),
    modifierInformationsCompte: APIReducer.bind(null, CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE),
    modifierQuestionsReponses: APIReducer.bind(null, CONTEXT_API_MODIFIER_QUESTIONS_REPONSES),
    recupererQuestions: APIReducer.bind(null, CONTEXT_API_RECUPERER_QUESTIONS),
    ajouterPersona: APIReducer.bind(null, CONTEXT_API_AJOUTER_PERSONA),
    verifierCodePostal: APIReducer.bind(null, CONTEXT_API_VERIFIER_CODE_POSTAL),
});

export default monCompte;
